import { Component, OnInit, ChangeDetectorRef, AfterViewInit, VERSION, ElementRef, TemplateRef } from '@angular/core';
import { Design } from './designTest.model';
import { FormGroup, FormControl, FormBuilder, Validators, NgForm, ValidationErrors } from '@angular/forms';
import { AuthenticationService, Item, TestData, Category, Complexity, Type, Checkqset, Question_Counter, Style } from '../services/authentication.service';
import { Router } from '@angular/router';
import { MediaMatcher } from '@angular/cdk/layout';
import { TestSchedulerService } from '../services/test_scheduler.service';
import { MatStepper } from '@angular/material';
import { QuestionSetService } from '../services/questionset.service';
import { ViewChild } from '@angular/core';
import { NgbModalOptions, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { faThumbsDown } from '@fortawesome/free-solid-svg-icons';
import { THIS_EXPR } from '@angular/compiler/src/output/output_ast';
import Swal from 'sweetalert2';

@Component({
  templateUrl: './designTest.component.html',
  styleUrls: ['./designTest.component.scss']
})
export class DesignTestComponent implements OnInit, AfterViewInit {
  private ngVersion: string = VERSION.full;
  @ViewChild('stepper') private myStepper: MatStepper;
  @ViewChild("text") text: ElementRef;
  @ViewChild("content") modalContent: TemplateRef<any>;
  @ViewChild("edit") modalEdit: TemplateRef<any>;
  q_set: Checkqset = { qsetname: '' }
  totalStepsCount: number;
  p: number = 1;
  selectedCategory;
  selectedCategoryindex: string;
  fieldArray: Array<Design> = [];
  dup_fieldArray: Array<Design> = [];
  array: Array<Design> = [];
  categoryName: Array<Design> = [];
  typeName: Array<Design> = [];
  complexityName: Array<Design> = [];
  newAttribute: any = {};
  Question_Category: any;
  result: boolean;
  details: boolean;
  typevalue: boolean = true;
  Category;
  Type;
  Complexity;
  complexityId: string;
  fname;
  lname;
  user;
  userAdmin: boolean;
  userSuperAdmin: boolean;
  userTestScheduler: boolean;
  userTestTaker: boolean;
  questionset: boolean;
  scheduletest: boolean;
  mobileQuery: MediaQueryList;
  elsecount: boolean;
  savebtn: boolean;
  categorybtn: boolean;
  setEmptyCheck: boolean;
  qpEmptyCheck: boolean;
  patternEmpty: boolean;
  typebtn: boolean;
  complexitybtn: boolean;
  countbtn: boolean;
  countbtn1: boolean;
  durationbtn: boolean;
  durationbtn1: boolean;
  overall: boolean;
  evaluate: boolean;
  private _mobileQueryListener: () => void;
  category: Category = {
    category_name: ''
  };
  
  type: Type = {
    cate_id: '',
    subcategory_id: '',
    style_id:''
  };
  complexity: Complexity = {
    cate_id: '',
    subcategory_id: '',
    type_id: ''
  };
  questioncount: Question_Counter = {
    Category_id: '',
    SubCategory_id: '',
    Complexity_id: '',
    type_id: '',
    style_id:''
  };
  style: Style = {
    cate_id: '',
    subcategory_id: ''
  }

  test: TestData = {
    id: '',
    FirstName: '',
    LastName: '',
    Email: '',
    Phone: '',
    Type: ''
  };

  designTest = new FormGroup({
    questionsetname: new FormControl(''),
    category: new FormControl(''),
    subcategory: new FormControl(''),
    type: new FormControl(''),
    complexity: new FormControl(''),
    count: new FormControl('')
  });

  myForm: FormGroup;
  submitted = false;
  unique: any;
  x: string;
  qpValidationCheck: boolean;
  myset: FormGroup;
  categoryEmptyCheck: boolean;
  subCategoryEmptyCheck: boolean;
  typeEmptyCheck: boolean;
  complexityEmptyCheck: boolean;
  countEmptyCheck: boolean;
  durationEmptyCheck: boolean;
  y: any;
  countValidationCheck: boolean;
  durationValidationCheck: boolean;
  name: boolean;
  qset: string;
  duplicate: boolean;
  subcategorybtn: boolean;
  Question_Sub_Category: any;
  selectedsubCategoryindex: any;
  selectedComplexityindex: any;
  selectedtypeindex: any;
  selectedsubCategory: any;
  selectedtype: any;
  selectedComplexity: any;
  questionCounter: any;
  question_count: any;
  question_counter: any;
  org_questioncount: boolean;
  Typelist: any;
  question_typelist: any;
  check_set: any = [];
  lastelem: number;
  duplicate_set_config: boolean;
  field_push: number;
  next: number = 0;
  validation_fail: number = 0;
  modalRef: any;
  set: any = [];
  cardopen: number = 0;
  card_opened: boolean = false;
  dupfield: number = 0;
  field: any = [];
  create_next_counter: number = 0;
  gettablecount: number = 0;
  finalset: any = [];
  setnextcounter: number = 0;
  fielder: any = [];
  delete_counter: number = 0;
  editcard_array: any = [];
  updateset: any = [];
  setindex: string;
  sectionEmptyCheck: boolean;
  section_name: any = [];
  fielder_last_elem: number;
  lastindex_deleted: Boolean = false
  fieldduplicatearray: any = [];
  section: any;
  array1: {};
  type_array: {};
  complexity_array: {};
  nextCounter: number = 0;
  tableIndex: number = 0;
  disableDeleteButton: boolean =false;
  counter: 6;
  questionstyleEmptyCheck: boolean;
  typedquestionStyle: any;
  enteredquestionStyle: any;
  question_stylelist: any;
  question_stylelist_filtered: any;
  userEvaluator: boolean;

  constructor(private fb: FormBuilder, private auth: AuthenticationService, private router: Router,
    private qs: QuestionSetService, private testschedulerservice: TestSchedulerService, changeDetectorRef: ChangeDetectorRef, media: MediaMatcher, private modal: NgbModal) {
    this.data();
    this.getAccess();
    this.simpletest();
    this.mobileQuery = media.matchMedia('(max-width: 600px)');
    this._mobileQueryListener = () => changeDetectorRef.detectChanges();
    this.mobileQuery.addListener(this._mobileQueryListener);
    this.createForm();
  }
  get No_of_Candidates() { return this.myForm.get('No_of_Candidates'); }


  ngOnInit() {
    this.getTempRowData();
    // this.section_name.push('Quantitative Aptitude')
    //
    this.get_section_name();
  }

  ngAfterViewInit() {
    this.totalStepsCount = this.myStepper._steps.length;
  }

  simpletest() {
    this.testschedulerservice.test_scheduler(this.test).subscribe(
      (data) => {

        this.user = sessionStorage.getItem('user');
        this.fname = sessionStorage.getItem('fname');

        this.lname = sessionStorage.getItem('lname');


        return this.result;
      },
      err => {
        console.error(err);
      }
    );
  }

  // getAccess(){
  //   this.user = sessionStorage.getItem('user');
  //   this.fname = sessionStorage.getItem('fname');

  //   this.lname = sessionStorage.getItem('lname');


  //   if (this.user === '2') {

  //     this.userAdmin = true;
  //     this.userSuperAdmin = false;
  //     this.userTestScheduler = true;
  //   } else if (this.user === '1') {

  //     this.userAdmin = true;
  //     this.userSuperAdmin = true;
  //     this.userTestScheduler = true;
  //   } else if (this.user === '3') {
  //     this.userAdmin = false;
  //     this.userSuperAdmin = false;
  //     this.userTestScheduler = true;
  //   }
  // }

  getAccess(){
    this.user = sessionStorage.getItem('user');
    this.fname = sessionStorage.getItem('fname');

    this.lname = sessionStorage.getItem('lname');


    if (this.user === '1') {
      this.userAdmin = true;
      this.userTestScheduler = false;
      this.userEvaluator = false;
    } else if (this.user === '2') {
      this.userEvaluator = true;
      this.userAdmin = false;
      this.userTestScheduler = false;
    } else if (this.user === '3') {
      this.userTestScheduler = true;
      this.userAdmin = false;
      this.userEvaluator = false;  
    }
  }

  createForm() {
    this.myForm = this.fb.group({
      questionsetname: ['', Validators.required],
      No_of_Candidates: ['', [Validators.required]],
      Unique_or_NonUnique: ['', Validators.required],
    });

  }
  get f() { return this.myForm.controls; }



  countValidator(control: FormControl): ValidationErrors | null {

    let cntval = control.value;
    if (cntval <= 0) {

      return {
        cntError: 'Count should be greater than zero.'
      };
    }
    return null;
  }

  data() {
   
    this.auth.category(this.category).subscribe(
      
      (data) => {

        this.Question_Category = data.results;
        console.log(this.Question_Category,"this.Question_Category******");//array have catname and cat id
        this.details = true;
        return this.Question_Category;
      },
      err => {
        console.error(err);
      }
    );
  }

  get_section_name() {
    console.log("this.cateeeeee",this.category)
    this.auth.section_name(this.category).subscribe(
      (data) => {

        this.section_name = data.results;
        console.log("section_name",this.section_name)//all sec id and sec name came from backend
        this.details = true;
        return this.section_name;
      },
      err => {
        console.error(err);
      }
    );
  }

  sectionchange(event: any, field : any) {

    let sample = event.target.value;
    let flag =0;
    console.log(sample,"sample");
    for (var i = 0; i < this.section_name.length; i++) {
      if(this.section_name[i].Section_Name == sample)
      { 
        flag=1;
        field.section = this.section_name[i].Id;
        console.log(field.section,"field.section***")
      }
    } 
    if(flag == 0)
    {
      field.section = null;
    }
}

  categorychange(event: any, field : any) {

      let sample = event.target.value
      for (var i = 0; i < this.Question_Category.length; i++) {
        if(this.Question_Category[i].Id == sample)
        {
          field.category_name = this.Question_Category[i].Category_Name;
        }
      } 
  }

  subcategorychange(event: any, field : any) {

    let sample = event.target.value
    for (var i = 0; i < this.Question_Sub_Category.length; i++) {
      if(this.Question_Sub_Category[i].Id == sample)
      {
        field.subcategory_name = this.Question_Sub_Category[i].Sub_Category_Name;
      }
    } 
  }
   

  typechange(event: any, field : any) {

    let sample = event.target.value
    for (var i = 0; i < this.question_typelist.length; i++) {
      if(this.question_typelist[i].typeid == sample)
      {
        field.type_name = this.question_typelist[i].Name;
      }
    } 
  }

  complexitychange(event: any, field : any) {

    let sample = event.target.value
    console.log("samplecom",sample)
    for (var i = 0; i < this.Complexity.length; i++) {
      if(this.Complexity[i].Id == sample)
      {
        field.complexity_name = this.Complexity[i].Complexity_Name;
      }
    } 
  }
  



  selectChangeHandler(event: any, i: any) {

    var map = new Map();

    this.categoryEmptyCheck = false

    this.selectedCategoryindex = i;

    this.selectedCategory = event.target.value;
    console.log("selectedCategory",this.selectedCategory );// cat id
    
    this.category.category_name = this.selectedCategory //here set category_ID in cat
    console.log(this.category.category_name,"ctname");
    this.type.cate_id = this.selectedCategory
    this.complexity.cate_id = this.selectedCategory
    this.style.cate_id = this.selectedCategory
    

    this.auth.subcategory(this.category).subscribe(
      (data) => {

        this.Question_Sub_Category = data.results;
        console.log(this.Question_Sub_Category,"subcat");
        
        this.details = true;
        return this.Question_Sub_Category;
      },
      err => {
        console.error(err);
      }
    );
  }

  //complexity changehandler
  complexityChangeHandler(event: any, i: any) {

    this.complexityEmptyCheck = false
    this.selectedComplexityindex = i;

    this.selectedComplexity = event.target.value;
    console.log(this.selectedComplexity,"selectedComplexity")
  }

  //type changehandler
  typeChangeHandler(event: any, i: any) {

    this.typeEmptyCheck = false

    this.selectedtypeindex = i;

    this.selectedtype = event.target.value;

    this.complexity.type_id = this.selectedtype

    this.auth.complexity(this.complexity).subscribe(
      (data) => {

        this.Complexity = data.results;
        console.log(this.Complexity,"rescom");
       
        this.details = true;
        return this.Complexity;
        
      },
      err => {
        console.error(err);
      }
    );

  }

  //count changehandler
  countChangeHandler(event: any, i: any , field : any) {


    this.countEmptyCheck = false
    this.countValidationCheck = false
    this.org_questioncount = false

    console.log(field.count)

    this.question_counter = field.count//entered count
     

    
    this.questioncount.Category_id = this.selectedCategory
    if(this.Complexity.length == 1){
      console.log("this.Complexity[0]",this.Complexity[0])
      this.selectedComplexity = this.Complexity[0].Id
      this.questioncount.Complexity_id = this.Complexity[0].Id
    }else{
    this.questioncount.Complexity_id = this.selectedComplexity
    }
    this.questioncount.SubCategory_id = this.selectedsubCategory
    this.questioncount.type_id = this.selectedtype
    this.questioncount.style_id = this.enteredquestionStyle
    console.log("this.questioncount*****",this.questioncount)


    this.auth.subcategory_count(this.questioncount).subscribe(
      (data) => {


        this.questionCounter = data.results[0].count;
        console.log( "questionCounter",this.questionCounter );
        if (this.question_counter > this.questionCounter) {
          this.org_questioncount = true
        }
        else {
          this.org_questioncount = false
        }
      },
      err => {
        console.error(err);
      }
    );
    // }

  }

  //subcategory changehandler
  subcategoryChangeHandler(event: any, i: any) {

    this.subCategoryEmptyCheck = false
    this.selectedsubCategoryindex = i;

    this.selectedsubCategory = event.target.value;


    this.complexity.subcategory_id = this.selectedsubCategory
    this.type.subcategory_id = this.selectedsubCategory
    this.style.subcategory_id = this.selectedsubCategory
    console.log("style cat id",this.style.cate_id);
    console.log("style sub cat id",this.style.subcategory_id)
//console.log("Pri sub cat id")
    this.auth.style(this.style).subscribe(
      data => {
    
        this.question_stylelist = data.results;
        console.log("Data.res inside ques style",data.results);
        console.log("Quest Styleee",this.question_stylelist)
     
        this.details = true;

       
        return this.question_stylelist;
  
  
      },
      err => {
        console.error(err);
      }
    );



  }

  getTempRowData() {
    // tslint:disable-next-line: max-line-length
    this.newAttribute = {
      question_set_id: '', questionsetname: '', No_of_Candidates: '', Unique_or_NonUnique: '', category: '', subcategory: '', type: '',style:'', typelist: [], typelistshow: true, complexity: '', count: '', duration: '', subcategory_name: '',
      complexity_name: '', type_name: '',style_name: '', category_name: '', section_name: '', section: ''
    };


    this.fieldArray.push(this.newAttribute);
  }
  
  onclickStyleDropdown(){
    console.log("this.Question_Sub_Category",this.Question_Sub_Category);
    console.log("style sub cat id",this.style.subcategory_id)

    if(this.Question_Sub_Category.length == 1){
      this.complexity.subcategory_id = this.Question_Sub_Category[0].Id
      this.type.subcategory_id = this.Question_Sub_Category[0].Id
      this.style.subcategory_id = this.Question_Sub_Category[0].Id
      this.selectedsubCategory = this.Question_Sub_Category[0].Id
    }
    console.log("this.subcategfory inside onclickStyleDropdown",this.style,this.type,this.complexity)
    this.auth.style(this.style).subscribe(
      data => {
    
        this.question_stylelist = data.results;
        console.log("Data.res inside ques style",data.results);
        console.log("Quest Styleee",this.question_stylelist)
     
        this.details = true;

       
        return this.question_stylelist;
  
  
      },
      err => {
        console.error(err);
      }
    );
  }

  onclickTypeDropdown(){
    console.log("inside onclick type dropdown",this.question_stylelist)
    console.log("this.type inside typedropdown***",this.type)
    if(this.question_stylelist.length == 1){
      this.type.style_id = this.question_stylelist[0].styleid
      this.enteredquestionStyle = this.question_stylelist[0].styleid
    }
    
    this.auth.type(this.type).subscribe(
      (data) => {
        console.log("data.results",data.results)

        this.question_typelist = data.results;
    
        
        this.details = true;
       // return this.Complexity;
        return this.question_typelist;
      },
      err => {
        console.error(err);
      }
    );
  }

  onclickComplexityDropdown(){
    console.log("inside onclick complexity dropdown",this.question_typelist)
    console.log("this.type inside typedropdown***",this.type)
    if(this.question_typelist.length == 1){
      this.complexity.type_id = this.question_typelist[0].typeid
      this.selectedtype= this.question_typelist[0].typeid
    }
    console.log("this.complexity",this.complexity)
    
    this.auth.complexity(this.complexity).subscribe(
      (data) => {

        this.Complexity = data.results;
        console.log(this.Complexity);       
        this.details = true;
        return this.Complexity;
        
      },
      err => {
        console.error(err);
      }
    );
  }

  questionStyleChangeHandler(event: any) {
    this.questionstyleEmptyCheck = false;
   // this.typedquestionTextindex = i;
    console.log("questionStyleEmptyCheck",this.questionstyleEmptyCheck);

    this.enteredquestionStyle = event.target.value;

    console.log("Event value of question style",event.target.value);
    
    this.type.style_id = this.enteredquestionStyle;
    console.log("this.type",this.type)
    
    this.auth.type(this.type).subscribe(
      (data) => {
        console.log("data.results",data.results)

        this.question_typelist = data.results;

        
        this.details = true;
       // return this.Complexity;
        return this.question_typelist;
      },
      err => {
        console.error(err);
      }
    );
    

    
  
    // k this.selectedQuestionMedia = this.selectedComplexity;
  }

  deleteFieldValue(index) {
    this.delete_counter = 0;
  //  this.lastindex_deleted = false;
    this.gettablecount = this.gettablecount - 1
    this.tableIndex = index
    console.log("index%%%",index)
    // if(index==0){
    //
    // this.fieldduplicatearray.push(this.fieldArray[0])
    // }

    console.log("^^^this.fieldArray.length",this.fieldArray.length)

    if(this.fieldArray.length-1 == 0)
    {
      this.fieldArray.push(this.newAttribute)
      this.fielder.push(this.newAttribute)
      this.disableDeleteButton = true
    }

    if (index == this.fieldArray.length - 1) {
      this.gettablecount = this.gettablecount + 1
      this.lastindex_deleted =  true
    }

    this.fielder.splice(index, 1);
    this.fieldArray.splice(index, 1);
    this.check_set.splice(index, 1);
    this.delete_counter = this.delete_counter + 1

    console.log("deleted fieldArray",this.fieldArray)

  }

  myClick() {
    //

  }

  sectionNameChange(event: any, field : any)
  {
    this.sectionEmptyCheck = false
    let sample = event.target.value;
    let flag =0;
    field.section_name = sample;
    console.log(sample);
    for (var i = 0; i < this.section_name.length; i++) {
      if(this.section_name[i].Section_Name == sample)
      { 
        flag=1;
        field.section = this.section_name[i].Id;
        
      }
    } 
    
    if(flag == 0)
    {
      field.section = null;
    }
  }

  durationChange()
  {
    this.durationEmptyCheck = false
    this.durationValidationCheck = false
  }

  patternChange(){
    this.patternEmpty = false
  }

  qpCountChange()
  {
    this.qpEmptyCheck = false
    this.qpValidationCheck = false
  }

  setNameChange(){
    this.setEmptyCheck = false
  }

  checkqset() {
    console.log(this.q_set,"this.q_set")// qnsetname getting
    this.auth.check_qset(this.q_set).subscribe(
      (data) => {

        if (data.code == 204) {
          this.duplicate = true
        }
        else {
          this.duplicate = false;
        }

        if ((this.duplicate) === false && (this.qpValidationCheck) === false && (this.qpEmptyCheck) === false && (this.setEmptyCheck) === false && (this.patternEmpty) === false) {
          this.fieldduplicatearray.push(this.fieldArray[0])
          console.log(this.fieldArray[0],"fieeeeld")
         console.log("fieldduplicatearray",this.fieldduplicatearray);
          this.nextCounter += 1
          this.goForward();


        }
      },
      err => {
        console.error(err);
      }

    );

  }

  create_next() {

//dub qnset check  function calling inside it
    

    //this.create_next_counter = this.create_next_counter + 1
    this.x = this.fieldArray[0].No_of_Candidates

    var candi = +this.x;

    this.q_set.qsetname = this.fieldArray[0].questionsetname
    console.log(this.q_set,"this.q_set");
    this.checkqset();



    if (this.fieldArray[0].questionsetname == '') {
      this.setEmptyCheck = true;

    }
    else {
      this.setEmptyCheck = false;

    }
    if (this.fieldArray[0].No_of_Candidates == '') {
      this.qpEmptyCheck = true;
    }
    else {
      this.qpEmptyCheck = false;
    }
    if (candi <= 0) {
      this.qpValidationCheck = true;
    }
    else {
      this.qpValidationCheck = false;
    }
    if (this.fieldArray[0].Unique_or_NonUnique == '') {
      this.patternEmpty = true;
    }
    else {
      this.patternEmpty = false;
    }


  }
  update_set(index , field) {
    this.updateset = this.updateset + 1
    this.setindex = localStorage.getItem('setindex')
    console.log(index);
    console.log(field,"field")
    console.log(this.set);
    if(field.section == null)
    {
      this.qs.getsectionid(this.set).subscribe(
        (data) => {

          field.section = data.results[0].insertId;//?
          console.log(field.section,"fieldofsec");
        })
      
    }
      
    this.modalRef.close(this.modalEdit)


    // this.fieldArray[this.setindex].category = this.editcard_array[0].category
    // console.log(this.fieldArray[this.setindex])
  }

  getcolor(){
    let color
    if(this.disableDeleteButton == true)
    {
      color = 'gray'
    }
    else{
      color = 'red'
    }

    return color

  }

  set_next() {
    //alert("wrong setnext")

    console.log(this.fieldArray,"fieldArray*****")
    console.log(this.newAttribute);
    
    if (this.delete_counter === 1) {
      this.fielder.push(this.newAttribute)
      //this.fieldArray.push(this.newAttribute)
    }
    if (this.lastindex_deleted === true) {
      this.fieldArray.push(this.newAttribute)
      console.log("newatrri",this.newAttribute)
      console.log("fieldArrayneww", this.fieldArray)
    }

    this.disableDeleteButton = false

    console.log("fieldArray*****", this.fieldArray)
    console.log("fieldArrayLen*****", this.fieldArray.length)

    this.lastindex_deleted = false
    this.delete_counter = 0


    this.field_push = this.fieldArray.length - 1



    this.set.push(this.fieldArray[this.field_push])
    this.setnextcounter = this.setnextcounter + 1

    


    this.validation_fail = 0



    for (let i = 0; i <= this.fieldArray.length - 1; i++) {
      this.x = this.fieldArray[i].count
     


      var count = +this.x;

      this.y = this.fieldArray[i].duration

      var duration = +this.y;
      if (this.fieldArray[i].category === '') {
        this.categoryEmptyCheck = true;
        // alert("Enter Correct Question Set details")
      }
      else {
        this.categoryEmptyCheck = false;

      }
      if (this.fieldArray[i].subcategory === '') {
        this.subCategoryEmptyCheck = true;
        // alert("Enter Correct Question Set details")
      }
      else {
        this.subCategoryEmptyCheck = false;

      }
      if (this.fieldArray[i].section === '') {
        this.sectionEmptyCheck = true;
        // alert("Enter Correct Question Set details")
      }
      else {
        this.sectionEmptyCheck = false;

      }
      if (this.fieldArray[i].type === '') {
        this.typeEmptyCheck = true;
      }
      else {
        this.typeEmptyCheck = false;
      }

      if (this.fieldArray[i].style === '') {
        this.questionstyleEmptyCheck = true;
      }
      else {
        this.questionstyleEmptyCheck = false;
      }
      if (this.fieldArray[i].complexity === '') {
        this.complexityEmptyCheck = true;
      }
      else {
        this.complexityEmptyCheck = false;
      }
      if (this.fieldArray[i].count === '') {
        this.countEmptyCheck = true;
      }
      else {
        this.countEmptyCheck = false;
      }
      if (count <= 0) {
        this.countValidationCheck = true;
      }
      else {
        this.countValidationCheck = false;
      }
      if (this.fieldArray[i].duration === '') {
        this.durationEmptyCheck = true;
      }
      else {
        this.durationEmptyCheck = false;
      }
      if (duration <= 0) {
        this.durationValidationCheck = true;
      }
      else {
        this.durationValidationCheck = false;
      }
      if (this.question_counter > this.questionCounter) {
        this.org_questioncount = true
      }
      else {
        this.org_questioncount = false
      }

      if (((this.durationValidationCheck === false) && (this.countValidationCheck === false) && (this.countEmptyCheck === false) && (this.categoryEmptyCheck === false) && (this.typeEmptyCheck === false) && (this.org_questioncount === false))) {
        if ((this.subCategoryEmptyCheck === false) && (this.sectionEmptyCheck === false) && (this.questionstyleEmptyCheck === false)) {
          if (this.durationEmptyCheck === false) {
            if (this.complexityEmptyCheck === false) {


              this.validation_fail = this.validation_fail + 1
            }

          }
        }


      }
    }


    if (this.validation_fail == this.fieldArray.length) {
      this.check_set_configuration()

    }
    else {
      this.fieldArray.splice(-1, 1);
      this.fieldArray.push(this.newAttribute)
    }

  }

  goBack(stepper: MatStepper) {
    stepper.previous();
  }

  // goForward(stepper: MatStepper){
  //   alert("pressed next")
  //   stepper.next();
  // }

  goNext() {

    this.nextCounter = 0
    this.myStepper.next();
    this.design();
  }

  goForward() {

    if(this.nextCounter == 1)
    {
            this.fielder.push(this.newAttribute)
    }
    this.myStepper.next();
    

  }

  open_set_card(index) {
    this.cardopen = this.cardopen + 1



    //Open modal on pressing escape
    // this.get_section_name();
    let ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false
    };
    this.modalRef = this.modal.open(this.modalContent, ngbModalOptions)
    if (this.cardopen > 1) {
      this.card_opened = true
      this.set.splice(0, this.set.length)
      console.log(this.set.length,"this.set.length")
      this.dupfield = this.dupfield + 1;
    console.log(this.dupfield ,"this.dupfield ******")


      if (this.dupfield > 1) {
        this.dup_fieldArray.splice(0, this.dup_fieldArray.length)
      }
      this.dup_fieldArray.push(this.newAttribute)
      console.log(this.dup_fieldArray,"dup_fieldArray");

    }



  }


  open_edit_card(index) {
    this.cardopen = this.cardopen + 1
    this.get_section_name();
    this.editcard_array = [];
    console.log(this.fieldArray[index],"fieldarray with index")
    this.editcard_array.push(this.fieldArray[index])
    console.log("editcard array", this.editcard_array)
    localStorage.setItem('setindex', index)
    //Open modal on pressing escape
    let ngbModalOptions: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false
    };

    if(this.editcard_array[0].category != 0)
    {
    this.modalRef = this.modal.open(this.modalEdit, ngbModalOptions)
    }

  }


  check_set_configuration() {
    //alert("wrong")
    this.duplicate_set_config = false;
    this.field_push = this.fieldArray.length - 1


    this.check_set.push(this.fieldArray[this.field_push])
    console.log("check_set",this.check_set)
    this.lastelem = this.check_set.length - 1;
    if (this.check_set.length > 1) {
      for (var i = 0; i < this.check_set.length - 1; i++) {
        console.log("check_set[i]",this.check_set[this.lastelem])
        if (this.check_set[this.lastelem].category == this.check_set[i].category && this.check_set[this.lastelem].subcategory == this.check_set[i].subcategory && this.check_set[this.lastelem].type == this.check_set[i].type && this.check_set[this.lastelem].complexity == this.check_set[i].complexity && this.check_set[this.lastelem].style == this.check_set[i].style) {

          this.duplicate_set_config = true;
          Swal.fire({
            title: 'Alert',
            text: 'Duplicate Set Config',
            icon: 'warning',
            showCancelButton: false,
            confirmButtonText: 'OK'
          }).then((result) => {
            if (result.isConfirmed) {
            }
          })
          this.check_set.splice(-1, 1);
        }
      }
      if (this.duplicate_set_config != true && this.org_questioncount == false) {


        this.getTempRowData()
        this.getsectionid()
        this.getTabledata()
        this.modalRef.close(this.modalContent)
      }


    }
    else {
      if (this.org_questioncount == false) {

        this.getTempRowData()

        // this.fieldArray.push(this.newAttribute);
        this.getsectionid()
        this.getTabledata()
        this.modalRef.close(this.modalContent)
      }

    }
  }

  getsectionid(){
    if(this.fielder[this.gettablecount].section == null)
    {
      this.qs.getsectionid(this.set).subscribe(
        (data) => {

          this.gettablecount = this.check_set.length -1
          this.fielder[this.gettablecount].section = data.results[0].insertId
          console.log(this.fielder[this.gettablecount].section);
        })
    }
  }

  getTabledata() {

    this.qs.gettabledata(this.set).subscribe(
      (data) => {


      this.gettablecount = this.check_set.length - 1
      console.log("gettabledata",data.results)
      console.log("gettablecount",this.gettablecount)

        if(data.results)
        {

        console.log("Data.res inside gettabledata",data.results);

        this.fielder[this.gettablecount].category_name = data.results[0].Category_Name
        this.fielder[this.gettablecount].subcategory_name = data.results[0].Sub_Category_Name
        this.fielder[this.gettablecount].type_name = data.results[0].Name
        this.fielder[this.gettablecount].style_name = data.results[0].Style_Name
        this.fielder[this.gettablecount].complexity_name = data.results[0].Complexity_Name;
       
        this.gettablecount = this.gettablecount + 1
        this.fielder.push(this.newAttribute)
        this.fielder_last_elem = this.fielder.length - 2
        for (var i = 0; i < this.fielder.length - 2; i++) {
          if (this.fielder[this.fielder_last_elem] == this.fielder[i]) {
            this.fielder.splice(this.fielder_last_elem, 1)
          }
        }
      }

      

      console.log("this.fielder",this.fielder)
      },
      err => {
        console.error(err);
      }
    );
  }


  design() {
    if (this.fieldArray[0].questionsetname === '') {
      this.fieldArray[0].questionsetname = this.fieldduplicatearray[0].questionsetname;
      this.fieldArray[0].No_of_Candidates = this.fieldduplicatearray[0].No_of_Candidates;
      this.fieldArray[0].Unique_or_NonUnique = this.fieldduplicatearray[0].Unique_or_NonUnique;
    }

    for (let i = 0; i <= this.fieldArray.length; i++) {


      var name = this.fname + " " + this.lname
    
      this.auth.designTest(this.fieldArray,name).subscribe(
        (data) => {
          this.submitted = true;

          if (data.code === 200) {
            // alert(data.success);
            // this.router.navigateByUrl('/question_set');
          } else {
            // alert(data.success);

          }
        },
        err => {
          console.error(err);
        }
      );
    }
  }

  generateSet() {


    console.log(this.fieldArray,"this.fieldarraylast")

    this.qs.generateSet(this.fieldArray).subscribe(
      (data) => {

        if (data.code === 200) {
         
          Swal.fire({
            title: 'Success',
            text: data.success,
            icon: 'success',
            showCancelButton: false,
            confirmButtonText: 'OK'
          }).then((result) => {
            if (result.isConfirmed) {
              this.router.navigateByUrl('/question_set');
            }
          })
        }else if (data.code === 400) {
          Swal.fire({
            title: 'Alert',
            text: data.failed,
            icon: 'warning',
            showCancelButton: false,
            confirmButtonText: 'OK'
          }).then((result) => {
            if (result.isConfirmed) {
              // this.router.navigateByUrl('/test_scheduler');
            }
          })

        }
      },
      err => {
        console.error(err);
      }
    );
  }


}

